import { api } from './api';
export const roleMatchingApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // AI提取剧本角色
        extractRoles: builder.mutation({
            query: (data) => ({
                url: '/ai/extract-roles',
                method: 'POST',
                body: data,
            }),
        }),
        // AI分析角色特征
        analyzeRoleCharacteristics: builder.mutation({
            query: (data) => ({
                url: '/ai/analyze-roles',
                method: 'POST',
                body: data,
            }),
        }),
        // 自动匹配演员
        autoMatchActors: builder.mutation({
            query: (data) => ({
                url: '/casting/auto-match',
                method: 'POST',
                body: data,
            }),
        }),
    }),
});
export const { useExtractRolesMutation, useAnalyzeRoleCharacteristicsMutation, useAutoMatchActorsMutation, } = roleMatchingApi;
